import { css as _css } from "@emotion/core";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
import AllhomesAgencyCard from './agency-card';
import AllhomesAgencyModel from './agency-model';
import * as styles from './agency-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgencyHeader = props => ___EmotionJSX("div", {
  css: /*#__PURE__*/_css([styles.header, !props.images.profilePhoto && styles.noProfilePhoto])
}, ___EmotionJSX("div", {
  css: styles.headerWrap
}, ___EmotionJSX("div", {
  css: styles.coverImageWrap
}, ___EmotionJSX(MultiResolutionImage, {
  css: styles.coverImage,
  src: props.images.coverPhoto || props.images.coverPhotoLowResolution,
  srcLowResolution: props.images.coverPhotoLowResolution,
  alt: props.name
}))), ___EmotionJSX("div", {
  css: styles.headerDetailsRow({
    photoPresent: Boolean(props.images.profilePhoto)
  })
}, props.images.profilePhoto && ___EmotionJSX("div", {
  css: /*#__PURE__*/_css([styles.profilePhoto, {
    backgroundColor: props.logoBackgroundColour
  }])
}, ___EmotionJSX("img", {
  css: styles.profilePhotoImage,
  src: props.images.profilePhoto,
  alt: props.name
})), ___EmotionJSX(AllhomesAgencyCard, props)));
AllhomesAgencyHeader.propTypes = _objectSpread({
  enquiryFormCallback: PropTypes.func.isRequired
}, AllhomesAgencyModel);
AllhomesAgencyHeader.defaultProps = {
  images: {} // eslint-disable-line
};
export default AllhomesAgencyHeader;